import React from 'react'
import { CustomerAddress } from 'lib/types/core'
import { Button } from 'lib/ui/components'
import { useHistory } from 'react-router-dom'
import { DISABLED_REGIONS } from 'hooks/useShippingRegionOptions'

interface Props {
  address: CustomerAddress
  handleDelete: () => void
  onDefaultShippingChange: (value: boolean) => void
  onDefaultBillingChange: (value: boolean) => void
  isFetching: boolean
  isDeleting: boolean
}

export const AddressActions: React.FC<Props> = ({ address, handleDelete, onDefaultShippingChange, onDefaultBillingChange, isFetching, isDeleting }) => {
  const {
    id,
    isDefaultBilling,
    isDefaultShipping
  } = address
  const history = useHistory()
  const isDisabledForShipping = DISABLED_REGIONS.includes(address.regionCode)

  return (
    <div className='actions'>
      <Button
        onClick={() => history.push(`/customer/account/addresses/edit/${id}`)}
        skin={Button.SKIN.TEXT}
        isDisabled={isFetching}
      >
        Edit
      </Button>
      {!isDefaultShipping && !isDisabledForShipping &&
        <Button
          skin={Button.SKIN.TEXT}
          isDisabled={isFetching}
          onClick={() => onDefaultShippingChange(true)}
        >
          Make Default Shipping Address
        </Button>}
      {!isDefaultBilling &&
        <Button
          skin={Button.SKIN.TEXT}
          isDisabled={isFetching}
          onClick={() => onDefaultBillingChange(true)}
        >
          Make Default Billing Address
        </Button>}
      <Button
        onClick={handleDelete}
        isLoading={isDeleting}
        skin={Button.SKIN.TEXT}
        isDisabled={isFetching || isDefaultShipping || isDefaultBilling}
      >
        Remove
      </Button>
    </div>
  )
}
